// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 106) return "static/chunks/106-c1c2bca3d03dc720.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "6ff06e915e43369e" + ".js";
};